import { jsx as _jsx } from "react/jsx-runtime";
import { StyledPill } from './Pill.style';
export function Pill({ label, disabled, variant = 'default', onClick, }) {
    return (_jsx(StyledPill, { title: label, variant: disabled ? 'disabled' : variant, disabled: disabled !== null && disabled !== void 0 ? disabled : variant === 'disabled', onClick: onClick, children: label }));
}
//# sourceMappingURL=Pill.js.map